import React from 'react'
import { css } from '@emotion/react'
import externalLink from '../images/svgs/external-link-white.svg'
import useGetAllBuilderProducts from '../hooks/useGetAllBuilderProducts'
import ProductCard from './product-card'

const linkStyle = theme => css({
    fontFamily: theme.fonts.secondary,
    fontWeight: 700,
    textTransform: 'capitalize',
    display: 'flex',
    gap: 8,
})

const productGridStyle = {
    display: 'grid', 
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: 20,
}

const dividerStyle = theme => css({ 
    marginTop: 24,
    paddingTop: 24,
    borderTop: `1px solid ${theme.colors.mutedDark}`,
})

export const Links = (props) => <>
    <a href='https://software.moogmusic.com/' target='_blank' rel='noreferrer' css={linkStyle}  {...props}>
        visit the moog software store
        <img src={externalLink} alt='external link' />
    </a>
</>

export default function NavSoftwareStore() {  
    const rootPath = 'Software Store'
    const products = useGetAllBuilderProducts()
        .filter(({ data }) => data.categories.lvl0 === rootPath)
    return <>
        <Links />
        <div css={[productGridStyle, dividerStyle]}>
            {products.slice(0, 4).map((product, i) => {
                return (
                    <ProductCard
                        key={`${product.objectID}-${i}`}
                        product={product}
                        external
                    />
                )
            })}
        </div>
    </>
}
